// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serialize Output Factor from database.
 * @see #/components/schemas/OutputFactor - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface OutputFactor {
    /**
     * The code for the Output Factor.
     * @dataFormat uuid
     */
    code: string;
    /**
     * The display name for the Output Factor.
     *
     */
    display_name: string;
    /**
     * The type for the Output Factor.
     *
     */
    type: string;
    /**
     * The unit for the Output Factor.
     *
     */
    unit: string;
    /**
     * The visibility for the Output Factor.
     *
     */
    is_visible: boolean;
    /**
     * The parent factor, if grouped.
     * @dataFormat uuid
     */
    parent?: string;
    /**
     * Defines if the output factor is relevant for the balance calculation.
     *
     */
    has_impact_on_balance: boolean;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for OutputFactor
 */
export namespace OutputFactor {
    /**
     * OutputFactor Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The code for the Output Factor.
         * @dataFormat uuid
         */
        code: string;
        /**
         * The display name for the Output Factor.
         * @type string (`dataFormat` is missing)
         */
        displayName: string;
        /**
         * The type for the Output Factor.
         * @type string (`dataFormat` is missing)
         */
        type: string;
        /**
         * The unit for the Output Factor.
         * @type string (`dataFormat` is missing)
         */
        unit: string;
        /**
         * The visibility for the Output Factor.
         * @type boolean (`dataFormat` is missing)
         */
        isVisible: boolean;
        /**
         * The parent factor, if grouped.
         * @dataFormat uuid
         */
        parent?: string;
        /**
         * Defines if the output factor is relevant for the balance calculation.
         * @type boolean (`dataFormat` is missing)
         */
        hasImpactOnBalance: boolean;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * OutputFactor DTO
     * Transforms OutputFactor model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend OutputFactor model */
        static toModel(obj: OutputFactor): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend OutputFactor model */
        static toApi(obj: Model): OutputFactor {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as OutputFactor;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
